export default __webpack_public_path__ + "static/media/head02_th_pc.6f4d1900.png";